exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "form[data-v-baa1f840]{padding:0 30px}form h1[data-v-baa1f840]{font-size:20px;text-align:center;line-height:60px}form ul[data-v-baa1f840]{font-size:16px;color:#333;line-height:30px}form ul li>span.title[data-v-baa1f840]{width:80px;text-align:right;display:inline-block}form .voucher[data-v-baa1f840]{padding:15px 55px 8px;background-color:#f5f5f5;margin:5px 0}form .voucher .user[data-v-baa1f840]{line-height:30px}form .sup[data-v-baa1f840]{height:30px}form .sup p[data-v-baa1f840]{line-height:30px;background-color:#fbfba5}form .sup p i[data-v-baa1f840]{font-size:24px;float:left;padding:0 5px}.btns[data-v-baa1f840]{padding-bottom:10px}", ""]);

// exports
